/**
 * @module web/store
 * @private
 */
import { cache } from "../persistence/cache";

let phoneVerificationData = null;

/**
 * Update the phone verification data received by the user.
 * @param {Object} newPhoneVerificationData - An object containing the smsTransactionId resulting from
 * verifying user's mobile phone.
 * @public
 */
const update = function(newPhoneVerificationData) {
  phoneVerificationData = newPhoneVerificationData;

  if (this.localCache && this.localCache.auth) {
    cache.set("phoneVerificationData", phoneVerificationData, {
      database: "auth",
      expiresIn: this.phoneVerificationDataExpirationTime
    });
  }
};

/**
 * Returns phone verification related data object stored in memory, where it will be searched for.
 * @returns {Object|null} - A found stored object containing the smsTransactionId resulting from verifying
 * user's mobile phone or null if not found in memory.
 * @public
 */
const get = async function() {
  let cachedPhoneVerificationData = null;
  if (this.localCache && this.localCache.auth) {
    cachedPhoneVerificationData = await cache.get("phoneVerificationData", { database: "auth" });
  }
  if (!phoneVerificationData && cachedPhoneVerificationData && cachedPhoneVerificationData.smsTransactionId) {
    phoneVerificationData = cachedPhoneVerificationData;
  }

  return phoneVerificationData.smsTransactionId;
};

export default { update, get };
